<header class="sticky top-0 bg-surface border-b border-outline flex items-center justify-between w-full px-6 py-3.5 shrink-0">

  <!-- Left: breadcrumbs -->
  <div class="flex items-center gap-1.5 min-w-0">
    @if (breadcrumbs().length > 1) {
      <button type="button"
              (click)="goBack()"
              class="flex items-center justify-center w-8 h-8 rounded-full text-on-surface
                     hover:bg-surface-container-high transition-colors shrink-0 mr-1">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
    }

    @for (crumb of breadcrumbs(); track crumb.url; let i = $index; let last = $last) {
      <span class="flex items-center gap-1.5 min-w-0">
        @if (last) {
          <span class="text-sm font-semibold text-primary truncate">{{ crumb.label }}</span>
        } @else {
          <a [routerLink]="crumb.url"
             class="text-sm text-inactive hover:text-on-surface transition-colors truncate cursor-pointer">
            {{ crumb.label }}
          </a>
          <svg class="w-3.5 h-3.5 text-inactive shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        }
      </span>
    }

    @if (breadcrumbs().length === 0) {
      <span class="text-sm font-semibold text-on-surface">Data Extraction Admin</span>
    }
  </div>

  <!-- Right: actions -->
  <div class="flex items-center gap-3 shrink-0">
    <div class="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-surface-container text-sm text-on-surface-container">
      <span class="w-2 h-2 rounded-full bg-tertiary shrink-0"></span>
      <span class="font-medium">{{ currentUserName }}</span>
    </div>
  </div>

</header>
